import type { Address, RangeChoice } from "./types"

export const gbp = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" })

export const dateFormatter = new Intl.DateTimeFormat("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric" })

export function money(pence: number) { return gbp.format(pence / 100) }

export function localDate(value: string) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
    return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : new Date(value)
}

export function formatDate(value: string) { return dateFormatter.format(localDate(value)) }

const shortDateFormatter = new Intl.DateTimeFormat("en-GB", { weekday: "short", day: "numeric", month: "short" })
export function formatShortDate(value: string) {
    const parts = shortDateFormatter.formatToParts(localDate(value))
    const part = (type: "weekday" | "day" | "month") => parts.find(item => item.type === type)!.value
    return `${part("weekday")}, ${part("day")} ${part("month").slice(0, 3)}`
}

export function formatPickerDate(value?: Date) { return value ? dateFormatter.format(value) : "Choose date" }

export function formatAddress(address: Address) {
    return [address.line1, address.line2, address.city, address.state, address.postal_code]
        .map((part) => part?.trim())
        .filter(Boolean)
        .join(", ")
}

export function toDateOnly(value: Date) {
    return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, "0")}-${String(value.getDate()).padStart(2, "0")}`
}

export function durationLabel(choice: RangeChoice | null) { return choice?.label ?? "Choose dates" }

export function hireDurationText(choice: RangeChoice) {
    const days = choice.hireDays
    return `${days} ${days === 1 ? "day" : "days"}`
}
